import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ng-if',
	templateUrl:'./NgIfPluginCompPage.html',
	styles: [],
	styleUrls:['./NgIfPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class NgIfPluginCompPage
{
	mdContent_1081 = `\`\`\`java
import com.jwebmp.core.angular.components.NgIf;
\`\`\``;
	mdContent_1082 = `\`\`\`java
new NgIf(String condition)
\`\`\``;
}
